import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';

export interface DropDownOption
{
    label: string;
    value: any;
    iconUrl: string | null;
}

@Component({
    selector: 'dropdown-component',
    templateUrl: './DropDownComponent.html',
    standalone: true,
    imports: [CommonModule],
    styleUrls: ['./DropDownComponent.css']
})
export class DropDownComponent
{
    @Input() options: DropDownOption[] = [];
    @Input() placeholder: string = 'Select...';
    @Input() selectedValue: any;

    @Output() selectedValueChange = new EventEmitter<any>();

    @ViewChild('dropDownList', { static: true }) dropDownList!: ElementRef<HTMLUListElement>;
    @ViewChild('dropDownTrigger', { static: true }) dropDownTrigger!: ElementRef<HTMLDivElement>;

    dropdownOpen = false;

    selectOption(option: DropDownOption)
    {
        this.selectedValue = option.value;
        this.selectedValueChange.emit(option.value);
        this.dropdownOpen = false;
    }

    toggleDropdown()
    {
        this.dropdownOpen = !this.dropdownOpen;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent)
    {
        const dropDownListEl = this.dropDownList.nativeElement;
        const dropDownTriggerEl = this.dropDownTrigger.nativeElement;

        if (this.dropdownOpen && !dropDownListEl.contains(event.target as Node) && !dropDownTriggerEl.contains(event.target as Node))
        {
            this.dropdownOpen = false;
        }
    }
}
